(function () {
  if (window.PlaygroundEvents) {
    window.PlaygroundEvents.init(document);
    return;
  }

  const instances = new Map();
  const months = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];

  function currentMonth(timezone) {
    let formatter;
    try {
      formatter = new Intl.DateTimeFormat('en-US', { timeZone: timezone, year: 'numeric', month: 'numeric' });
    } catch (error) {
      formatter = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric' });
    }
    const parts = {};
    formatter.formatToParts(new Date()).forEach(function (part) { parts[part.type] = part.value; });
    return Number(parts.year) * 12 + Number(parts.month) - 1;
  }

  function eventMonth(item) {
    const month = months.indexOf((item.dataset.eventMonth || '').trim().toUpperCase());
    const year = Number(item.dataset.eventYear);
    return month >= 0 && Number.isInteger(year) && year >= 1900 && year <= 9999 ? year * 12 + month : null;
  }

  function initSection(section) {
    if (instances.has(section)) return;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const tabs = Array.from(section.querySelectorAll('[data-filter]'));
    const items = Array.from(section.querySelectorAll('.ce-item'));
    const switchBox = section.querySelector('.taeb-switch');
    const panel = section.querySelector('.ce-events-list');
    const empty = section.querySelector('.ce-empty-state');
    const dialog = section.querySelector('dialog');
    const flyerImage = dialog.querySelector('img');
    const flyerTitle = dialog.querySelector('.ce-flyer-title');
    const flyerStatus = dialog.querySelector('.ce-flyer-status');
    const retryButton = dialog.querySelector('[data-flyer-retry]');
    let selected = section.dataset.defaultFilter || 'all';
    let month = currentMonth(section.dataset.timezone);
    let trigger;
    let previousOverflow;
    let imageUrl;
    let imageTimeout;

    function matches(item, filter) {
      if (filter === 'all') return true;
      const key = eventMonth(item);
      if (key === null) return false;
      return filter === 'this_month' ? key === month : key > month;
    }

    function applyFilter(filter) {
      selected = tabs.some(function (tab) { return tab.dataset.filter === filter; }) ? filter : 'all';
      month = currentMonth(section.dataset.timezone);
      let visible = 0;
      items.forEach(function (item) {
        const show = matches(item, selected);
        item.hidden = !show;
        item.classList.toggle('ce-hidden', !show);
        if (show) visible++;
      });
      tabs.forEach(function (tab) {
        const active = tab.dataset.filter === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('active-text', active);
        tab.querySelector('.ce-badge-count').textContent = items.filter(function (item) { return matches(item, tab.dataset.filter); }).length;
        if (active) {
          switchBox.className = 'taeb-switch pos-' + tab.dataset.index;
          panel.setAttribute('aria-labelledby', tab.id);
        }
      });
      empty.hidden = visible !== 0;
    }

    function refreshMonth() {
      if (currentMonth(section.dataset.timezone) !== month) applyFilter(selected);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { applyFilter(tab.dataset.filter); }, options);
      tab.addEventListener('keydown', function (event) {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        applyFilter(tabs[next].dataset.filter);
        tabs[next].focus();
      }, options);
    });

    function showImageError() {
      window.clearTimeout(imageTimeout);
      flyerImage.hidden = true;
      flyerStatus.hidden = false;
      flyerStatus.textContent = dialog.dataset.errorText;
      retryButton.hidden = false;
    }

    function loadImage() {
      window.clearTimeout(imageTimeout);
      flyerImage.hidden = true;
      flyerStatus.hidden = false;
      flyerStatus.textContent = dialog.dataset.loadingText;
      retryButton.hidden = true;
      flyerImage.removeAttribute('src');
      imageTimeout = window.setTimeout(showImageError, 20000);
      flyerImage.src = imageUrl;
    }

    flyerImage.addEventListener('load', function () {
      if (!dialog.open) return;
      window.clearTimeout(imageTimeout);
      flyerImage.hidden = false;
      flyerStatus.hidden = true;
      retryButton.hidden = true;
    }, options);
    flyerImage.addEventListener('error', function () {
      if (dialog.open && flyerImage.getAttribute('src')) showImageError();
    }, options);
    retryButton.addEventListener('click', loadImage, options);

    section.addEventListener('click', function (event) {
      const button = event.target.closest('[data-event-flyer]');
      if (!button || !section.contains(button)) return;
      event.preventDefault();
      if (dialog.open) return;
      imageUrl = button.dataset.eventFlyer;
      trigger = button;
      flyerTitle.textContent = button.dataset.eventTitle;
      flyerImage.alt = button.dataset.eventTitle;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      loadImage();
    }, options);

    function restorePage() {
      window.clearTimeout(imageTimeout);
      flyerImage.removeAttribute('src');
      if (previousOverflow !== undefined) {
        document.body.style.overflow = previousOverflow;
        previousOverflow = undefined;
      }
      if (trigger && trigger.isConnected) trigger.focus();
    }

    dialog.querySelector('[data-flyer-close]').addEventListener('click', function () { dialog.close(); }, options);
    dialog.addEventListener('close', restorePage, options);
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }, options);
    document.addEventListener('visibilitychange', refreshMonth, options);
    window.addEventListener('focus', refreshMonth, options);
    section.addEventListener('shopify:block:select', function (event) {
      const item = items.find(function (entry) { return entry.dataset.blockId === event.detail.blockId; });
      if (item && item.hidden) applyFilter('all');
    }, options);
    const interval = window.setInterval(refreshMonth, 60000);
    instances.set(section, function () {
      if (dialog.open) dialog.close();
      restorePage();
      abort.abort();
      window.clearInterval(interval);
      instances.delete(section);
    });
    applyFilter(selected);
  }

  function init(root) {
    instances.forEach(function (dispose, section) { if (!section.isConnected) dispose(); });
    if (root.matches && root.matches('[data-events-section]')) initSection(root);
    root.querySelectorAll('[data-events-section]').forEach(initSection);
  }

  window.PlaygroundEvents = { init: init };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, section) { if (event.target.contains(section)) dispose(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
